import React, { Component } from 'react';
import { 
    Link
} from "react-router-dom";
import logo from "../assets/img/logo.png";
import $ from 'jquery';




class Header extends Component {

  render() {


    return (
     <section id="header" className="click-rel index-bg">
    <div className="top-bar">
      <div className="container">


        <div className="navigation" id="navigation-scroll">
        <div className="row">
         <div className="col-md-11 col-xs-9">
          <Link to="/"> <img src={logo} className="img-responsive add-m-top-5" width="250" height="50" alt="Website Designing"/></Link>
        </div>
        <div className="col-md-1 col-xs-3">
          <p className="nav-button 0">
           <button className="add-m-btm-1" id="trigger-overlay" onClick={this.overlayOpen} type="button">
            <i className="fa fa-3x fa-bars my-sizes"></i>
             MENU
          </button>
        </p>
        </div>
        </div>
        </div>
    
      </div>
        </div>
        

 <div className="overlay overlay-hugeinc add-m-btm-20">
        <button type="button" className="overlay-close" onClick={this.overlayClose} >Close</button>
        <nav>
          <ul>
            <li className="hideit" onClick={this.overlayClose}><Link to="/">Home</Link></li>
            <li className="hideit" onClick={this.overlayClose}><Link to="About">About Us</Link></li>
            <li className="hideit" onClick={this.overlayClose}><Link to="Product">Product</Link></li>
            <li className="hideit" onClick={this.overlayClose}><Link to="Services">Services</Link></li>
            <li className="hideit" onClick={this.overlayClose}><Link to="#">Portfolio</Link></li>
            <li className="hideit" onClick={this.overlayClose}><Link to="#">Blog</Link></li>
            <li className="hideit" onClick={this.overlayClose}><Link to="#">Contact Us</Link></li>
          </ul>
        </nav>
      </div>

  </section>
    );
  }



  overlayOpen(e) {

    e.preventDefault();

    $('.overlay').addClass('open');

    
  }
  overlayClose(e) {

    e.preventDefault();

    $('.overlay').removeClass('open');

    
  }

  



 /* componentDidMount() {
    $.addEventListener('load', this.handleLoad);
  }*/


}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header.js